const Actions = {
  DELETE: 'Delete',
  DOWNLOAD_DELETE: 'Download and delete',
};

module.exports = Actions;
